export enum FAILED_LIST_BUTTON {
  ALL = 'ALL',
  READY_TO_RELEASE = 'READY_TO_RELEASE',
  RELEASING = 'RELEASING',
  REVOKED = 'REVOKED',
  RELEASED = 'RELEASED',
}

export const failedListFiltersMap: Record<
  FAILED_LIST_BUTTON,
  { label: string; filter: any }
> = {
  [FAILED_LIST_BUTTON.ALL]: { label: 'All', filter: {} },
  [FAILED_LIST_BUTTON.READY_TO_RELEASE]: {
    label: 'Ready to Release',
    filter: { released: null },
  },
  [FAILED_LIST_BUTTON.RELEASING]: {
    label: 'Releasing',
    filter: { released: false, revoked: false },
  },
  [FAILED_LIST_BUTTON.REVOKED]: { label: 'Revoked', filter: { revoked: true } },
  [FAILED_LIST_BUTTON.RELEASED]: {
    label: 'Released',
    filter: { released: true },
  },
};
